import React, { useEffect } from 'react';
import { reportProps } from './StopLossAggregateTable';
import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { EnrollmentChartFormat } from '../core-utils/helper-utils/enrollmentMetricsHelpers';
import {
  CardComponent,
  EnrollmentHealthCareChart,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import enrollmentMetricsMessages from '../core-utils/messages/enrollmentMetricsMessages';
import EmptyData from '../_components/atoms/Icons/EmptyData';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

const EnrollmentTypeChart: React.FC<reportProps> = ({ data }) => {
  const useStyles = makeStyles()({
    emptyDataIconGrid: {
      marginTop: '80px',
      marginBottom: '20px',
    },
  });
  const { classes } = useStyles();

  const getDataForEnrollmentHealthCareChart = () => {
    const returnData: EnrollmentChartFormat[] = [];
    let allZero = true;
    data?.healthcareData?.forEach((element: any) => {
      const obj = {
        label: element.subscriptionType,
        value: String(element.count),
      };
      if (element?.count > 0) {
        allZero = false;
      }
      returnData.push(obj);
    });

    return allZero ? [] : returnData;
  };
  useEffect(() => {}, []);
  return (
    <Box style={{ marginRight: '12px', width: '38%' }}>
      {getDataForEnrollmentHealthCareChart()?.length === 0 ? (
        <CardComponent
          title={enrollmentMetricsMessages.enrollmentHealthCareChart.TITLE}
          body={
            <Grid
              container
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Grid className={classes.emptyDataIconGrid}>
                <EmptyData />
              </Grid>
              <Grid>
                <Typography
                  fontSize="14px"
                  fontType="regular"
                  lineHeight="24.78px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                >
                  {
                    enrollmentMetricsMessages.enrollmentHealthCareChart
                      .emptyText
                  }
                </Typography>
              </Grid>
            </Grid>
          }
          height="300px"
          width="300px"
        />
      ) : (
        <EnrollmentHealthCareChart
          chartData={getDataForEnrollmentHealthCareChart()}
          cardHeight={'300px'}
          cardWidth={'95%'}
          chartHeight={'250'}
          chartWidth={'400'}
          yAxisMargin="0.3rem 0"
          title={'Enrollment Tiers'}
          subtitle=""
          xAxisLabel="Employee Count"
          yAxisLabel=""
          showValue
        />
      )}
    </Box>
  );
};
export default EnrollmentTypeChart;
